import { ArraySerializer, Field, Model, Type } from 'serialize-ts';
import { ModelMetadataSerializer } from 'serialize-ts/dist/serializers/model-metadata.serializer';

@Model()
export class EecLabelAttribute {
  @Field()
  code?: string | null;

  @Field()
  value?: string | null;

  @Field()
  default?: boolean;
}

@Model()
export class EecLabelClassRange {
  @Field()
  min?: string | null;

  @Field()
  max?: string | null;

  @Field()
  from?: string | null;

  @Field()
  to?: string | null;
}

@Model()
export class EecLabels {
  @Field()
  class?: string | null;

  @Field()
  labelUrl?: string | null;

  @Field()
  dataSheetUrl?: string | null;

  @Field()
  @Type(new ModelMetadataSerializer(EecLabelClassRange))
  classRange?: EecLabelClassRange | null;

  @Field()
  @Type(new ArraySerializer(new ModelMetadataSerializer(EecLabelAttribute)))
  attributes?: Array<EecLabelAttribute> | null;
}
